import request from '@/utils/request'

const tradeDepartmentApi = {
  tradeDepartmentList: '/trade/department/',
  tradeDepartmentCreate: '/trade/department/',
  tradeDepartmentUpdate: '/trade/department/',
  tradeDepartmentDelete: '/trade/department/'
}

/**
 * 列表
 */
export function tradeDepartmentList (parameter) {
  return request({
    url: tradeDepartmentApi.tradeDepartmentList,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function tradeDepartmentCreate (parameter) {
  return request({
    url: tradeDepartmentApi.tradeDepartmentCreate,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function tradeDepartmentUpdate (parameter, trade_department_id) {
  return request({
    url: tradeDepartmentApi.tradeDepartmentUpdate + trade_department_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 删除
 */
export function tradeDepartmentDelete (trade_department_id) {
  return request({
    url: tradeDepartmentApi.tradeDepartmentDelete + trade_department_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
